<div class="pagar-productos">
  <h2>PAGAR MIS PRODUCTOS</h2>
  <div *ngIf="!modoPago" class="pagar-productos-container">
    <div class="col-left">
      <div
        style="margin-bottom: 1.25rem"
        *ngFor="let item of productos; index as i"
      >
        <app-colapsable
          [title]="item.Nombre"
          ($expandedChange)="expandChange(item.Nombre)"
        >
          <div body>
            <app-pagar-productos
              [idPoliza]="item.Poliza.toString()"
              [showTotalResumen]="false"
              ($returnDataAPagar)="getDataAPagar($event)"
            ></app-pagar-productos>
          </div>
        </app-colapsable>
      </div>
    </div>
    <div class="col-right resumen-container">
      <div appKeepVerticalScroll class="resumen">
        <h4 style="margin: 0px">RESUMEN</h4>
        <p class="labelResumen">Primas seleccionadas:</p>
        <div
          class="total-mount"
          style="display: grid;grid-template-columns: 1fr 1fr;"
        >
          <div>
            <h4 style="margin: 0px">
              TOTAL
            </h4>
          </div>
          <div style="margin: 0px;text-align: right">
            <span class="label">$</span>
            <span class="value">{{ total | number }}</span>
          </div>
        </div>
        <button
          class="button-pagar"
          (click)="onPagar()"
          mat-flat-button
          [disabled]="total <= 0"
        >
          Pagar
        </button>
      </div>
    </div>
  </div>

  <div>
    <app-webpay
      *ngIf="modoPago"
      [dataAPagar]="checkedPays"
      ($closeWebPay)="closeWebPay($event)"
      [isTokuOptionVisible]="true"
    ></app-webpay>
  </div>
</div>
